import { LiveChip } from './LiveChip';

export const LiveTooltipHeader = ({ chipLabel }: { chipLabel: string }) => <LiveChip label={chipLabel} />;
